/**
 * Client-safe display formatters (no server imports).
 */

/** Formats an amount as currency with exactly two decimals (en-US locale). */
export function formatCurrency(
  amount: number,
  currencyCode: string = "USD"
): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

/** Truncates text to maxLength characters, appending "..." when cut. */
export function truncateText(text: string, maxLength: number = 50): string {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + "...";
}

/**
 * Formats a payment amount in the given currency (defaults to USD), falling
 * back to a plain "$x.xx" string if the currency code is invalid.
 */
export function formatPaymentAmount(
  amount: number,
  currency?: string | null
): string {
  try {
    return formatCurrency(amount, currency || "USD");
  } catch {
    return `$${amount.toFixed(2)}`;
  }
}
